import Item from "./Item";

class Equipment extends Item {
    constructor (v) {
        super (v);
        this.type = v.type;
        this.attackRange = {
            min : v.minAttack ? v.minAttack : 0,
            max : v.maxAttack ? v.maxAttack : 0,
        };
        this.defense = v.defense ? v.defense : 0;
    }
}

export default Equipment;
